import React from "react";

export default function KbArticleSettings({ article, onChange, departments = [], categories = [], subcategories = [] }) {
  const set = (field, value) => onChange({ ...article, [field]: value });
  return (
    <aside className="kbv2-settings">
      <h2>Article settings</h2>
      <label>Audience
        <select value={article.audience_type} onChange={(e) => set("audience_type", e.target.value)}>
          <option value="end_user">End user</option><option value="assignee">Technician</option>
        </select>
      </label>
      <label>Department
        <select value={article.department_id || ""} onChange={(e) => onChange({ ...article, department_id: e.target.value, category_id: "", subcategory_id: "" })}>
          <option value="">Select department</option>
          {departments.map((item) => <option key={item.id} value={item.id}>{item.name}</option>)}
        </select>
      </label>
      <label>Category
        <select value={article.category_id || ""} disabled={!article.department_id} onChange={(e) => onChange({ ...article, category_id: e.target.value, subcategory_id: "" })}>
          <option value="">No category</option>
          {categories.map((item) => <option key={item.id} value={item.id}>{item.name}</option>)}
        </select>
      </label>
      <label>Subcategory
        <select value={article.subcategory_id || ""} disabled={!article.category_id} onChange={(e) => set("subcategory_id", e.target.value)}>
          <option value="">No subcategory</option>
          {subcategories.map((item) => <option key={item.id} value={item.id}>{item.name}</option>)}
        </select>
      </label>
      <div className="kbv2-settings-note">Draft and publishing will be connected to the V2 backend in Step 3.</div>
    </aside>
  );
}
